import { DrmQuality } from '@dtvgo/backend-service';
import { KeySystem } from '@dtvgo/player-common-utils';

function getPlaybackSources(options) {
  const {
    playbackInfo: { drmId, drms, manifest },
    getAuthHeaders
  } = options;
  const keySystemsConfigPerQuality = getKeySystemsConfigPerQuality({ drms, drmId, getAuthHeaders });
  return getSourceObjectArray(manifest, (drmQuality) => keySystemsConfigPerQuality[drmQuality]);
}
const KeySystemConfigGetter = {
  [KeySystem.PLAYREADY]: getPlayreadyConfig,
  [KeySystem.WIDEVINE]: getWidevineConfig,
  [KeySystem.FAIRPLAY]: getFairplayConfig
};
function getKeySystemsConfigPerQuality(options) {
  const { drms, drmId, getAuthHeaders } = options;
  if (!drms)
    return {};
  const keySystemsConfigPerQuality = {};
  for (const [keySystemName, drmConfigs] of Object.entries(
    drms
  )) {
    const castedKeySystemName = keySystemName;
    const getKeySystemConfig = KeySystemConfigGetter[castedKeySystemName];
    if (!getKeySystemConfig || !drmConfigs)
      continue;
    for (const drmConfig of drmConfigs) {
      const qualityToUse = drmConfig.quality || DrmQuality.DEFAULT;
      if (!keySystemsConfigPerQuality[qualityToUse])
        keySystemsConfigPerQuality[qualityToUse] = {};
      keySystemsConfigPerQuality[qualityToUse][castedKeySystemName] = getKeySystemConfig({
        config: drmConfig,
        drmId,
        getAuthHeaders
      });
    }
  }
  return keySystemsConfigPerQuality;
}
function getPlayreadyConfig(options) {
  const { config, drmId, getAuthHeaders } = options;
  return {
    keySystem: KeySystem.PLAYREADY,
    defaultLicenseUrl: getLicenseUrl(config.licenseUrl, drmId),
    getLicenseHeaders: async (...args) => ({
      ...await getAuthHeaders(...args),
      "Content-Type": "text/xml; charset=utf-8",
      SOAPAction: "http://schemas.microsoft.com/DRM/2007/03/protocols/AcquireLicense"
    })
  };
}
function getWidevineConfig(options) {
  const { config, drmId, getAuthHeaders } = options;
  return {
    keySystem: KeySystem.WIDEVINE,
    defaultLicenseUrl: getLicenseUrl(config.licenseUrl, drmId),
    certificateUrl: config.certificateUrl ?? void 0,
    getLicenseHeaders: getAuthHeaders
  };
}
function getFairplayConfig(options) {
  const { config, drmId, getAuthHeaders } = options;
  return {
    keySystem: KeySystem.FAIRPLAY,
    defaultLicenseUrl: getLicenseUrl(config.licenseUrl, drmId),
    certificateUrl: config.certificateUrl ?? void 0,
    getLicenseHeaders: getAuthHeaders
  };
}
function getLicenseUrl(licenseUrl, drmId) {
  if (!drmId)
    return licenseUrl;
  const url = new URL(licenseUrl);
  url.searchParams.set("contentId", drmId);
  return url.toString();
}
function getSourceObjectArray(manifestObject, getKeySystemsConfig) {
  return [
    {
      dash: manifestObject.dash?.lowLatency || void 0,
      hls: manifestObject.hls?.lowLatency || void 0,
      drmQuality: DrmQuality.LOW_LATENCY,
      isLowLatency: true,
      isPrimary: false
    },
    {
      dash: manifestObject.dash?.primary || void 0,
      hls: manifestObject.hls?.primary || void 0,
      drmQuality: DrmQuality.DEFAULT,
      isLowLatency: false,
      isPrimary: true
    }
  ].filter((source) => source.dash || source.hls).map((source) => ({
    ...source,
    keySystemsConfig: getKeySystemsConfig(source.drmQuality)
  }));
}

export { getPlaybackSources };
//# sourceMappingURL=getPlaybackSources.js.map
